export default __webpack_public_path__ + "static/media/product05-1-480x360.88ebb0d0.jpg";